import { Component, OnInit, ViewChild } from '@angular/core';
import { AddUpdateMerchantViewModel } from '../../../models/add-update-merchant-view-model';
import { ContactDetailsViewModel } from '../../../models/contact-details-view-model';
import { UserDataStoreService } from '../../../services/user-data-store.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PermissionEnum } from '../../../services/guards/permissions';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SignupContactComponent } from '.././signup-contact/signup-contact.component';
import { SignupTerminalComponent } from '../signup-terminal/signup-terminal.component';
import { CreateResult } from '../../../models/create-result';
import { SignupSummaryComponent } from '.././signup-view-summary/signup-summary.component';
import { Observable } from 'rxjs';
import { merchantTerminalsLink } from '../../../models/merchant-terminals-link';
import Swal from 'sweetalert2';
import { SignupMerchantComponent } from '../signup-merchant/signup-merchant.component';

@Component({
  selector: 'app-merchant-sign-up',
  templateUrl: './signup-base.component.html',
  styleUrls: ['./signup-base.component.scss']
})
export class MerchantSignUpComponent implements OnInit {

  public merchantTypeIndicators: string;
  public remainingCount$: Observable<number>;
  public remainingCount: number;
  public redirect: boolean = false;
  public canManage = false;
  public raiseDanger: boolean = false;
  public steps = 0;
  public showPrev = "'none'";
  public showNext = 'show';
  public toBeDeleted = false;
  public prevBtns = document.querySelectorAll(".btn-prev");
  public nextBtns = document.querySelectorAll(".btn-next");
  public progress = document.getElementById("progress");
  public formSteps = document.querySelectorAll(".form-step");
  public progressSteps = document.querySelectorAll(".progress-step");
  public createResult: CreateResult;
  public hasErrorMessage: CreateResult;
  public message: string = "Sorry, an error has occurred";
  public hasError: boolean = false;
  isChecked: string = '';
  public _addUpdateMerchantViewModel: AddUpdateMerchantViewModel;
  public _contactDetailsViewModel: ContactDetailsViewModel;
  @ViewChild(SignupMerchantComponent) _signupMerchantComponent: SignupMerchantComponent;
  @ViewChild(SignupContactComponent) _signupContactComponent: SignupContactComponent;
  @ViewChild(SignupTerminalComponent) _signupTerminalComponent: SignupTerminalComponent;
  @ViewChild(SignupSummaryComponent) _signupSummaryComponent: SignupSummaryComponent;

  constructor(private _toastService: ToastrService,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private merchantTerminalsLink: merchantTerminalsLink) {
    this._ngxUiLoaderService.start();
    var canManage = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantSignUp]);
    if (!canManage) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }
    this._ngxUiLoaderService.stop();
  }

  public async ngOnInit(): Promise<void> {
    this.progress = document.getElementById("progress");
    this.formSteps = document.querySelectorAll(".form-step");
    this.progressSteps = document.querySelectorAll(".progress-step");
    this.prevBtns = document.querySelectorAll(".btn-prev");
    this.nextBtns = document.querySelectorAll(".btn-next");
  }

  updateFormSteps(direction: number) {
    for (var i = 0; i < this.formSteps.length; i++) {
      if (this.formSteps[i].classList.contains("form-step-active")) {
        this.formSteps[i].classList.remove("form-step-active");
        this.formSteps[i + direction].classList.add("form-step-active");
        break;
      }
    }
  }

  updateProgressbar(steps: number) {
    this.progressSteps.forEach((progressStep, idx) => {
      if (idx < (steps + 1)) {
        progressStep.classList.add("progress-step-active");
      } else {
        progressStep.classList.remove("progress-step-active");
      }
      const progressActive = document.querySelectorAll(".progress-step-active");
      this.progress.style.width = ((progressActive.length - 1) / (this.progressSteps.length - 1)) * 100 + "%";
    });
  }

  async next() {
    debugger;
    this.hasError = false;

    var isValid = await this.IsValideWidzard();
    if (!isValid) {
      return;
    }
    this.steps++;
    this.updateFormSteps(1);
    this.updateProgressbar(this.steps)
  }

  prev() {
    this.steps--;
    this.updateFormSteps(-1);
    this.IsValideWidzard();
    this.updateProgressbar(this.steps)
  }

  async IsValideWidzard(): Promise<boolean> {
    debugger;
    switch (this.steps) {
      case 0:
        var response = await this._signupMerchantComponent.validateForm();
        if (response.success) {
          this._signupContactComponent.setContactData(this._signupMerchantComponent.isExistingMerchant);
        }
        else {
          return this.showErrorMessage(await (response).message);
        }
        break;
      case 1:
        debugger;
        var response = await this._signupContactComponent.validateForm();
        if (response.success) {
          this._signupContactComponent.setContactData(this._signupMerchantComponent.isExistingMerchant);
          this._signupTerminalComponent.setTerminalData();
        }
        else {
          return this.showErrorMessage(response.message);
        }
        break;
      case 2: 
         
        this.merchantTerminalsLink.terminals = this._signupTerminalComponent.deviceList;
        if (this.merchantTerminalsLink.terminals.length === 0) {
          this._toastService.error("Please add atleast one terminal");
          return this.showErrorMessage("Please add atleast one terminal");
        }
        if (this.merchantTerminalsLink.isbulkOrder == true && this.merchantTerminalsLink.terminals.length <= 1) {
          this._toastService.error("Please add atleast two and more terminals for a bulk order");
          return this.showErrorMessage("Please add atleast two and more terminals for a bulk order");
        }
        this._signupSummaryComponent.setSummaryData();
        break;
      default:
    }
    return true;
  }

  async save() {
    try {
      this._ngxUiLoaderService.start();
      debugger;
      if (this.merchantTerminalsLink.merchantTypeIndicator === "New merchant") {
        //Handle New Merchant
        const merchantResponse = await this._signupMerchantComponent.saveAsync() as CreateResult;

        if (!merchantResponse.success) {
          this.showPopupErrorMessage('Error saving merchant details', merchantResponse.message);
          return;
        }

        const contactResponse = await this._signupContactComponent.saveAsync();
        if (!contactResponse.success) {
          this.showPopupErrorMessage('Error saving merchant contact details', 'Error saving merchant contact details');
          return;
        }

      } else {
        //Handle Existing Merchant
        debugger;
        const merchantNumber = this.merchantTerminalsLink.merchant.merchantNumber;
        const getMerchantSignup = await this._signupMerchantComponent.getMerchantSignUp(merchantNumber);
        if (getMerchantSignup === null) {
          await this._signupMerchantComponent.addUpdateMerchantSignUp(this.merchantTerminalsLink);
        }

        var getMerchant = await this._signupMerchantComponent.getMerchant(merchantNumber);
        if (getMerchant?.merchantStreetAddress == null || getMerchant?.merchantStreetAddress == undefined) {
          //update address
          await this._signupMerchantComponent.updateMerchant(getMerchant);
        }

        const getMerchantContact = await this._signupContactComponent.GetContactDetails(merchantNumber, this.merchantTerminalsLink.merchant.participantId.toString());
        if (getMerchantContact != null && (getMerchantContact.emailAddress !== this.merchantTerminalsLink.contact.emailAddress)) {
          await this._signupContactComponent.updateContactDetails(getMerchantContact);
        }

      }
      const isSuccessful = await this.saveTerminals();

      if (isSuccessful) {
        this.showPopupMessage();
      }

    } catch (error) {
      debugger;
      console.log(error);
      this.showPopupErrorMessage('Error during the save process: ');
    } finally {
      this._ngxUiLoaderService.stop();
    }
  }

  async saveTerminals() {
    debugger;
    let isSuccessful: boolean = true;
    var createTerminal: CreateResult = await this._signupTerminalComponent.saveTerminalSignup()
    if (createTerminal.success) {
      var results: CreateResult[] = [];
      results.push();
      results.push(await this._signupTerminalComponent.saveTerminalContact());
      results.push(await this._signupTerminalComponent.saveTerminalInteractions());
      results.push(await this._signupTerminalComponent.activateTerminals());
      results.push(await this._signupTerminalComponent.saveNotes());
      results.push(await this._signupTerminalComponent.SendNotification());

      results.forEach(result => {
        if (!result.success) {
          this._ngxUiLoaderService.stop();
          isSuccessful = false;
          this.showPopupErrorMessage('Error processing terminal', result.message);
        }
      });
    }
    else {
      this._ngxUiLoaderService.stop();
      isSuccessful = false;
      this.showPopupErrorMessage('Request failed.', createTerminal.message);
    }
    return isSuccessful;
  }

  showPopupMessage() {

    let timerInterval;
    Swal.fire({
      title: 'Merchant and terminal(s) saved successfully!',
      html: "Redirecting in <b></b> seconds.",
      timer: 10000,
      icon: 'success',
      timerProgressBar: true,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-primary px-4'
      },
      didOpen: () => {
        timerInterval = setInterval(() => {
          const content = Swal.getHtmlContainer();
          if (content) {
            const b: any = content.querySelector('b');
            if (b) {
              b.textContent = Math.ceil(Swal.getTimerLeft() / 1000)
            }
          }
        }, 100);
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer || result.isConfirmed) {
        this._router.navigate(['management', 'terminal-staging', this._signupMerchantComponent._merchant.merchantNumber]);
      }
    });

  }

  showPopupErrorMessage(title: string, text: string = '') {
    Swal.fire({
      title: title,
      text: text || title,
      icon: "error"
    });
  }

  formHasError(response: CreateResult) {
    debugger;
    if (!response.success) {
      return this.showErrorMessage(response.message);
    }
    else {
      this.hasError = false;
      this._ngxUiLoaderService.stop();
    }
  }

  showErrorMessage(message): boolean {
    this.message = message;
    this.hasError = true;
    this._ngxUiLoaderService.stop();
    return false;
  }
}




